import {loaderDisable, loaderEnable} from "../bvcomponents/ui/loaderView";
import store from "../store";
import Analytics from "../analytics";
import {resetUserPassword, userLogin, userRegister} from "../api/user-api";
import {showQuoteSavedNotification} from "../bvcomponents/ui/successNotification";
import {saveQuote} from "../api/server-api";
import {getAnalyticsEcommerceValues} from "../analyticsEcommerceParams";
import {restorePaymentInfo} from "../actions/paymentFunctions";

export const loginButtonCommonClick = async (updateInputValidations, analyticsLabel) => {
  await updateInputValidations();
  const errors = store.getState().userState.userInfoErrors;
  if (Object.keys(errors).length && Object.keys(errors)
    .filter(key => key === "email" || key === "password")
    .some(key => errors[key] && errors[key].length)) {
    return false
  }
  loaderEnable();
  Analytics.sendClickEvent(analyticsLabel);
  const {currency, value} = getAnalyticsEcommerceValues();
  Analytics.sendEcommerceEvent("generate_lead", {currency, value});

  const loginResponse = await userLogin();
  loaderDisable();
  return loginResponse
}

export const saveQuoteAfterSignIn = async () => {
  loaderEnable();
  const savedSuccess = await saveQuote({submit: true, showReceipt: false});
  if (savedSuccess) {
    showQuoteSavedNotification("successNotification.titleQuoteSaved");
    document.kvConfig.jobId = savedSuccess.jobId;
  }
  loaderDisable();
  return savedSuccess
}

export const registerButtonCommonClick = async (updateInputValidations, analyticsLabel, executeAfterRegisterIfUserExist) => {
  await updateInputValidations();
  const {userState} = store.getState();
  const errors = userState.userInfoErrors;
  if (Object.keys(errors).length && Object.keys(errors)
    .filter(key => key !== "password")
    .some(key => errors[key] && errors[key].length)) {
    return false
  }
  if (userState.userInfo) {
    store.dispatch(restorePaymentInfo({ // on register - fill in also shipping, why not
      shippingAddress: {
        address1: userState.userInfo.address1,
        address2: userState.userInfo.address2,
        fullName: userState.userInfo.firstName + " " + userState.userInfo.lastName,
        city: userState.userInfo.city,
        state: userState.userInfo.state,
        postal: userState.userInfo.postal,
      }
    }))
  }
  loaderEnable();
  Analytics.sendClickEvent(analyticsLabel);
  const {currency, value} = getAnalyticsEcommerceValues();
  Analytics.sendEcommerceEvent("generate_lead", {currency, value});

  const registeredResponse = await userRegister({executeAfterRegisterIfUserExist});
  console.log("successfully registered", registeredResponse);
  loaderDisable();
  return registeredResponse
}

export const remindPasswordCommonClick = async (updateInputValidations, analyticsLabel) => {
  await updateInputValidations();
  const fullStore = store.getState();
  // const {language} = fullStore.serverState;
  // const {userInfo, userInfoErrors} = fullStore.userState;
  const {userInfoErrors} = fullStore.userState;

  if (userInfoErrors.email && userInfoErrors.email.length) {
    return false
  }
  // loaderEnable();
  Analytics.sendClickEvent(analyticsLabel);
  await resetUserPassword();
  // loaderDisable();
}
